import script from "./OrgAccountLicense.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgAccountLicense.vue?vue&type=script&setup=true&lang=js"

import "./OrgAccountLicense.vue?vue&type=style&index=0&id=e33cacc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e33cacc8"]])

export default __exports__